module.exports = __webpack_public_path__ + "static/media/link-icon.f63cc5f4.svg";